/**
 * SyncManager: coordina la sincronización del outbox local con el backend.
 *
 * Triggers de sync:
 *  - Cada 30s (interval)
 *  - Al detectar evento 'online' del navegador
 *  - Al pedir explícitamente flushOutbox()
 */
import { syncApi } from './api'
import { db } from './db'

const SYNC_INTERVAL_MS = 30_000
const MAX_RETRY = 5

let isRunning = false

export async function flushOutbox(): Promise<{ sent: number; failed: number }> {
  if (isRunning) return { sent: 0, failed: 0 }
  isRunning = true
  let sent = 0
  let failed = 0

  try {
    const pending = await db.outbox
      .where('sync_status')
      .equals('PENDING')
      .toArray()

    if (pending.length === 0) return { sent: 0, failed: 0 }

    const eventos = pending.map((e) => ({
      uuid: e.uuid,
      comida_elegida_id: e.comida_elegida_id,
      tipo_evento: e.tipo_evento,
      payload: e.payload,
      qr_token: e.qr_token,
      timestamp_local: e.timestamp_local,
    }))

    try {
      const res = await syncApi.pushBatch(eventos)
      // Marcar como sincronizados
      await db.outbox
        .where('uuid')
        .anyOf(pending.map((e) => e.uuid))
        .modify({ sync_status: 'SYNCED' })
      sent = res.procesados + res.duplicados_ignorados
    } catch (err: any) {
      // Incrementar retry counts
      for (const ev of pending) {
        if (ev.retry_count >= MAX_RETRY) {
          await db.outbox.update(ev.uuid, {
            sync_status: 'FAILED',
            last_error: err.message,
          })
        } else {
          await db.outbox.update(ev.uuid, {
            retry_count: ev.retry_count + 1,
            last_error: err.message,
          })
        }
      }
      failed = pending.length
    }
  } finally {
    isRunning = false
  }

  return { sent, failed }
}

export function startSyncManager() {
  // Sync periódico
  setInterval(flushOutbox, SYNC_INTERVAL_MS)
  // Sync al recuperar conexión
  window.addEventListener('online', () => {
    console.log('[Sync] Conexión recuperada, enviando outbox')
    flushOutbox()
  })
  // Primer intento al cargar
  flushOutbox()
}

export async function getOutboxStats() {
  const pending = await db.outbox.where('sync_status').equals('PENDING').count()
  const failed = await db.outbox.where('sync_status').equals('FAILED').count()
  return { pending, failed }
}
